module.exports = __webpack_public_path__ + "static/media/gopuram.951e9e4a.svg";